import { AppSEO, AppSEOProps } from 'components/core/AppSEO/AppSEO';
import { PageFooter } from 'components/layout/Page/components/PageFooter';
import { PageHeader } from './components/PageHeader';
import styled from 'styled-components';
import { PageHeaderLayoutProps } from 'components/layout/Page/components/PageHeaderLayout';
import { PageNavSection, PageNavSectionProps } from 'components/layout/Page/components/PageNavSection';

const StyledMain = styled.main`
  display: flex;
  flex: 1;
`;

const StyledWrapper = styled.div <{ $isGreyBackground: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #fff;
  ${props => props.$isGreyBackground && `background-color: #fcfcfc`};
`;

interface Props {
  children: React.ReactNode;
  hasHeader?: boolean;
  hasNavSection?: boolean;
  isGreyBackground?: boolean;
  /** Important SEO props that must be defined for each page */
  appSEOProps?: AppSEOProps;
  headerProps?: Omit<PageHeaderLayoutProps, 'children'>;
  navSectionProps?: PageNavSectionProps;
  /** TODO: impl */
  footerProps?: any;
}

export const Page = ({
  children,
  appSEOProps,
  isGreyBackground = false,
  hasHeader = true,
  headerProps,
  footerProps,
  hasNavSection = false,
  navSectionProps,
}: Props) => {
  return (
    <StyledWrapper $isGreyBackground={isGreyBackground}>
      <AppSEO {...appSEOProps} />
      {hasHeader ? <PageHeader {...headerProps} /> : null}
      {hasNavSection ? <PageNavSection {...navSectionProps} /> : null}
      <StyledMain>{children}</StyledMain>
      <PageFooter {...footerProps} />
    </StyledWrapper>
  );
};
